/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRoundaboutLeft = createReactComponent("outline", "arrow-roundabout-left", "IconArrowRoundaboutLeft", [["path", { "d": "M3 9h8a5 5 0 1 1 5 5v7", "key": "svg-0" }], ["path", { "d": "M7 5l-4 4l4 4", "key": "svg-1" }]]);

export { IconArrowRoundaboutLeft as default };
//# sourceMappingURL=IconArrowRoundaboutLeft.mjs.map
